export * from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components/TyreQuestionResults/components/TyreTable/components/TyreTableRow/components/TyreActions/components/TyreActionSelector";
